module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-swipeout-item",
    on: {
      "touchstart": _vm.start,
      "mousedown": _vm.start,
      "touchmove": _vm.move,
      "mousemove": _vm.move,
      "touchend": _vm.end,
      "mouseup": _vm.end,
      "touchcancel": _vm.end
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.distX >= 0),
      expression: "distX >= 0"
    }],
    staticClass: "vux-swipeout-button-box vux-swipeout-button-box-left",
    style: (_vm.leftButtonBoxStyle)
  }, [_vm._t("left-menu")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.distX <= 0),
      expression: "distX <= 0"
    }],
    staticClass: "vux-swipeout-button-box",
    style: (_vm.rightButtonBoxStyle)
  }, [_vm._t("right-menu")], 2), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "vux-swipeout-content",
    style: (_vm.styles),
    on: {
      "mousedown": _vm.onContentClick,
      "touchstart": _vm.onContentClick
    }
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad1f01f2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/swipeout/swipeout-item.vue
// module id = 730
// module chunks = 0